<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Name</th>
          <th class="text-left">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(input, index) in inputs"
          :key="index"
        >
          <td>{{ input.settings.name }}</td>
          <td>
            <v-switch
              disabled
              v-model="input.value"
            ></v-switch>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <!-- <v-row justify="center"> -->
  <!-- <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Raum hinzufügen</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Raum hinzufügen</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Name*" v-model="room.name" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Betriebsmodus" v-model="room.operatingMode" required></v-text-field>
              </v-col>             
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Sollwert" v-model="room.setPoint" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Istwert" v-model="room.currentTemp" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Schließen</v-btn>
          <v-btn color="blue darken-1" text @click="save()">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  <!-- </v-row> -->
  <!-- </v-container> -->
</template>

<script>
export default {
  name: 'Inputs',

  data: () => ({
    inputs: [],
    dialog: false
  }),

  created () {
    this.getInputs()
    setInterval(() => {
      this.getInputs()
    }
      , 1000)
  },
  methods: {
    getInputs () {
      this.$http.get('/api/unipi/inputs').then((response) => {
        this.inputs = response.data
      })
    },
    save () {
      this.$http.post('/api/rooms', this.room).then(() => {
        this.close()
      })
    },
    changeMode (room) {
      // eslint-disable-next-line no-console
      console.log(room)
      this.$http.post('/api/rooms/change', { id: room.id, value: room.operatingMode }).then(() => {
        this.close()
      })
    },
    close () {
      this.dialog = false
      this.initRoom()
    }
  }

};
</script>
